import { AutoStopRecordingModal } from "@/components/modal/auto-stop-recording/auto-stop-recording-modal";
import { DeleteRecordingModal } from "@/components/modal/delete-recording/delete-recording-modal";
import { AUDIO_RECORDING_AUTO_STOP_LIMIT_DURATION } from "@/store/audio/recording/auto-stop";
import { useMemo } from "react";

interface AudioCaptureModalsProps {
  isAutoStopModalVisible: boolean;
  onAutoStopClose: () => void;
  isDeleteModalOpen: boolean;
  onDeleteClose: () => void;
  onDeleteConfirm: () => void;
}

export function AudioCaptureModals({
  isAutoStopModalVisible,
  onAutoStopClose,
  isDeleteModalOpen,
  onDeleteClose,
  onDeleteConfirm,
}: AudioCaptureModalsProps) {
  const { title, message } = useMemo(
    () => ({
      title: "Recording stopped automatically",
      message: `This recording reached the maximum time limit (${AUDIO_RECORDING_AUTO_STOP_LIMIT_DURATION.toFormat("h 'hours'")}) and was stopped.`,
    }),
    []
  );

  return (
    <>
      <AutoStopRecordingModal
        isOpen={isAutoStopModalVisible}
        onClose={onAutoStopClose}
        title={title}
        message={message}
      />
      <DeleteRecordingModal
        isOpen={isDeleteModalOpen}
        onClose={onDeleteClose}
        onDelete={onDeleteConfirm}
      />
    </>
  );
}
